import React from 'react';
import { bio, bioTagline, event } from '../data/masterclass';
export function Bio() {
  return <section aria-labelledby="bio-heading" className="border-y border-ink-line bg-ink" data-id="element-13" data-mp="3j82xx4a9fypb">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-start gap-10 px-6 py-20 sm:grid-cols-[minmax(220px,0.75fr)_1.25fr] sm:gap-12 lg:py-24" data-id="element-14" data-mp="12850uwxut96">
        <img src={event.portraitUrl} alt="Curtis and Spring Eatmon IV" className="w-full max-w-sm object-cover" data-id="element-15" data-mp="3t3wjte9vd4jr" />

        <div data-id="element-16" data-mp="30i4syx1relpw">
          <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-17" data-mp="30imwmeqr427u">
            Your hosts
          </p>
          <h2 id="bio-heading" className="mt-3 font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-18" data-mp="3eakuftf0ibop">
            Curtis &amp; Spring Eatmon IV
          </h2>

          <div className="mt-6 space-y-5" data-id="element-19" data-mp="2hqu1oes4g6xh">
            {bio.map(paragraph => <p key={paragraph} className="leading-relaxed text-white/70 sm:text-lg" data-id="element-20" data-mp="2horc1vuvsfta">
                {paragraph}
              </p>)}
          </div>

          <p className="mt-8 border-l-2 border-gold pl-6 font-display text-2xl font-semibold uppercase leading-snug text-gold sm:text-3xl" data-id="element-21" data-mp="1h4tkysfiggwl">
            {bioTagline}
          </p>
        </div>
      </div>
    </section>;
}